import { AlertColor, Avatar, Box, Divider, LinearProgress, Link, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { EmptyContainer } from "../../components/KeydriveComponents/EmptyContainer/EmptyContainer";
import { KeyDriveBodyMin } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveh4Header } from "../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { ShareUser } from "../../assets/icons/ShareUser";
import { ShareNotFound } from "../../assets/icons/ShareNotFound";
import { GetSharedFileUserLogged, GetUsersSharedFile, UndoItemSharing } from "../../services/SharedFileServices";
import { SharedItemModel } from "../../model/SharedItemModel";
import { GenericTablePagination } from "../../components/KeydriveComponents/Tables/GenericTablePagination";
import { PaginationResult } from "../../model/PaginationResult";
import ButtonWithPopoverFilter from "./components/ButtonWithPopoverFilter";
import { SharedItemRequestModel } from "../../model/SharedItemRequestModel";
import { OrgPreferences, UserMinimal } from "../../model/UserModel";
import ItemOptionsMenu from "./components/ItemOptionsMenu";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { Download, GetOneItem } from "../../services/Item/ItemServicesGet";
import ShareFile, { ShareFileConfig } from "../WorkSpaceItem/PanelItens/ShareFile/ShareFileComp";
import { KeyDriveDrawer } from "../../components/KeydriveComponents/Drawer/KeyDriveDrawer";
import WorkSpaceItemListFileComponentImage from "../WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import Snackbar from "../../components/Snackbar/SnackbarContainer";
import copy from "copy-to-clipboard";
import { GetOneWorkSpace } from "../../services/WorkSpaceServices";
import i18n from "../i18n/I18n";
import { createFavorite, deleteFavorite, getAllFavorites } from "../../services/favoriteServices";
import { ICreateFavoriteVO, IFavoriteModel, WorkSpaceUserName } from "../../model/ItemModel";
import { FavoriteType } from "../../enums/FavoriteType";
import ChoicerViwerModal from "../WorkSpaceItem/Viwer/ChoicerViwerModal";
import { ConvertWorkspaceToChoicerViwer } from "../WorkSpaceItem/Viwer/Convert/ConvertWorkSpaceUserName";
export const SharedItem = () => {

    const { nameOrg } = useParams();
    var requestDefaultPagination: SharedItemRequestModel = { pageSize: 15, nameOrgInternal: nameOrg! };
    const { t } = useTranslation();
    const { preferences, id } = useProfile();
    const [loading, setLoading] = useState<boolean>(false);
    const [sharedItems, setSharedItems] = useState<PaginationResult<SharedItemModel>>({ pageSize: 0, pageCurrent: 1, totalItems: 0, totalPages: 0, items: [] });
    const [favorites, setFavorites] = useState<IFavoriteModel[]>([]);
    const [usersSharedItem, setUsersSharedItem] = useState<UserMinimal[]>([])
    const [openDrawer, setOpenDrawer] = useState<boolean>(false)
    const [showSnackBar, setShowSnackBar] = useState<boolean>(false);
    const [messageSnack, setMessageSnack] = useState<string>("");
    const [alertColor, setAlertColor] = useState<AlertColor>("success");
    const [shareFileConfig, setShareFileConfig] = useState<ShareFileConfig | undefined>(undefined)
    const [sharedItemName, setSharedItemName] = useState<string | undefined>(undefined)
    const profile = useProfile();
    const [orgPreferences, setOrgPreferences] = useState<OrgPreferences>();
    const [itemIdConst, setItemIdConst] = useState<string | undefined>(undefined)
    const [isOpenConst, setIsOpenConst] = useState<boolean>(false)
    const [nameConst, setNameConst ] = useState<string | undefined>(undefined)
    const [extensionConst, setExtensionConst] = useState<string | undefined>(undefined)
    const [WorkSpaceItem, setWork] = useState<WorkSpaceUserName[]>([]);
    const exibirViewerBoolean = (exibir: boolean) => {
        setIsOpenConst(exibir);
    };
    
    const exibirViewer = (idMongo: string, name: string, extension: string) => {
        updateContent(idMongo, name, extension)
        exibirViewerBoolean(true);
    };

    const updateContent = (id: string, name: string, extension: string) => {
        setItemIdConst(id)
        setNameConst(name)
        setExtensionConst(extension)
    }
    
    const getWorkspaceWhenVisible = () => {
        if (itemIdConst)
            GetOneItem(itemIdConst!)
            .then((newWork) => {
                setWork([newWork]);
            });
    };

    const handleApplyFilter = (filterData: SharedItemRequestModel) => {
        searchSharedItems({ ...requestDefaultPagination, ...filterData })
    };


    const canSeeShareItem = (item: SharedItemModel): boolean => {
        if (profile.adminSystem) return true;

        let organizationFound = profile.organizations?.filter(org => org.internalName == nameOrg);
        if (organizationFound == undefined || organizationFound?.length <= 0) return false;
        
        if (organizationFound[0].isAdmin) return true;

        if (profile.id == item.userSharedOwnerId) return true;

        return false;

    };

    const columns = [
        {
            header: "",
            render: (row: SharedItemModel) => (
                <Stack direction="row" alignItems="center" spacing={1}>
                    {<ItemOptionsMenu
                    itemIdUnShared={row.id}
                    emails={row.usersAccess}
                        downloadFile={() => downloadFile(row.itemId, row.itemName, row.itemExtension)}
                        sharedFile={ 
                            canSeeShareItem(row) ? 
                            () => sharedItem(row.itemId, `${row.itemName}.${row.itemExtension}`, row.userSharedOwnerId)
                            :undefined
                        }
                        copyFileLinkUrl={() => copyDocumentLinkUrl(row.itemId)}
                        unshared={canSeeShareItem(row) ? unshare: undefined}
                    />}
                </Stack>
            ),
        },
        {
            header: t("SharedItem.name"),
            render: (row: SharedItemModel) => (
                <div style={{cursor: "pointer"}} onClick={()=>exibirViewer(row.itemId, row.itemName, row.itemExtension)}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <div style={{ marginRight: '16px' }}>
                            <WorkSpaceItemListFileComponentImage boxLayout={false} extension={row.itemExtension} isFolder={false} />
                        </div>
                        <Typography sx={{
                            overflow: "hidden",
                            overflowWrap: "break-word",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "300px",
                            "&:hover": { textDecoration: "underline"}
                        }}>{row.itemName}</Typography>
                    </Stack>
                </div>
            ),
        },
        {
            header: t("SharedItem.dateShared"),
            render: (row: SharedItemModel) => {
                dayjs.extend(utc)
                const date = dayjs(row.dateCalendar);
                var data = `${(i18n.language == 'pt-BR')?date.format('DD/MM/YYYY'):date.format('MM/DD/YYYY')} `;
                return row.containsExpirationDate? data : t("SharedItem.noExpiration");
            },
        },
        {
            header: t("SharedItem.sharedBy"),
            render: (row: SharedItemModel) => (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar sx={{ width: 24, height: 24 }}>
                        {row.userSharedUsername[0].toUpperCase()}
                    </Avatar>
                    <Typography variant="body2">
                        {row.userSharedUsername}{" "}
                        <Typography component="span" variant="body2" color="text.secondary">
                            ({row.userSharedEmail})
                        </Typography>
                    </Typography>
                </Stack>
            ),
        },
        {
            header: t("SharedItem.usersWithAccess"),
            align: "left" as const,
            render: (row: SharedItemModel) => (
                <KeyDriveBodyMin 
                    color="#22638D"
                    text={`${row.usersAccess.length.toString().padStart(2, "0")} ${t("SharedItem.users")}`}
                    needBold={false}
                    needEllipses={false}
                />
            ),
        },
    ];

    useEffect(() => {
        profile.organizations?.forEach(org => {
            if(nameOrg == org.internalName){
                setOrgPreferences(org);
            }
        })
        searchSharedItems(requestDefaultPagination)
        getFavorites()
    }, [])

    function searchSharedItems(request?: SharedItemRequestModel) {
        setLoading(true);
        GetSharedFileUserLogged(request)
            .then((res) => {
                setSharedItems(res);
                GetUsersSharedFile(nameOrg!)
                    .then((resUsers) => {
                        var userWithoutUserLogged = resUsers;
                        setUsersSharedItem(userWithoutUserLogged);
                    })
            })
            .finally(() => {
                setLoading(false)
            })
    };

    function getFavorites() {
        if (nameOrg !== undefined) {
            getAllFavorites(nameOrg!, id!)
                .then((response) => {
                    setFavorites(response.favoriteUserVO);
                })
        }
    }

    function updatePanelSave() {
        setOpenDrawer(false);
        searchSharedItems(requestDefaultPagination);

        setShowSnackBar(true);
        setMessageSnack(`${t("SharedItem.theDocument")} ${sharedItemName} ${t("SharedItem.hasBeenSharedSuccessfully")}`);
        setAlertColor("error");
    }

    async function unshare(itemId: string, emails: UserMinimal[]) {
       for (let i = 0; i < emails.length; i++) {
        await UndoItemSharing(itemId, emails[i].email, nameOrg!)
            .then((data) => {
                setShowSnackBar(true)
                setMessageSnack(`${t("SharedItem.unsharedSuccess")} ${emails.length > 1 ? t("SharedItem.all") : emails[i].email}`)
                setAlertColor('success')
            })
            .catch(() => {
                setShowSnackBar(true)
                setMessageSnack(t("SharedItem.unsharedFail"))
                setAlertColor('error')
            })
            if(emails.length-1 == i){
                searchSharedItems(requestDefaultPagination)
            }
       }

    }

    function downloadFile(itemId: string, itemName: string, itemExtension: string) {
        if (itemId) {
            Download(itemId!)
                .then((blob) => {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", itemName + "." + itemExtension);
                    document.body.appendChild(link);

                    link.click();
                    link.parentNode?.removeChild(link);

                    setShowSnackBar(true);
                    setMessageSnack(t("DownloadSuccess.message"));
                })
                .catch((error) => {
                    if (
                        error.response &&
                        error.response.data &&
                        typeof error.response.data === "string"
                    ) {
                        let blob = new Blob([error.response.data]);
                        blob
                            .text()
                            .then((message) => {

                                setShowSnackBar(true);
                                setMessageSnack(message);
                                setAlertColor("error");
                            })
                            .catch(() => {

                                setShowSnackBar(true);
                                setMessageSnack(t("DownloadFileError.message"));
                                setAlertColor("error");
                            });
                    } else {
                        setShowSnackBar(true);
                        setMessageSnack(t("DownloadFileError.message"));
                        setAlertColor("error");
                    }
                });
        }
    }

    function sharedItem(itemId: string, itemFullName: string, sharedById: string) {
        setOpenDrawer(!openDrawer);
        let shareFileConfig: ShareFileConfig = {
            itemId: itemId,
            sharedById
        }
        setSharedItemName(itemFullName);
        setShareFileConfig(shareFileConfig);

    }

    const copyDocumentLinkUrl = (itemId: string) => {
        const documentLinkUrl = window.location.protocol + '//' + window.location.host + '/file/' + itemId;
        copy(documentLinkUrl);
        setShowSnackBar(true);
        setMessageSnack(t("Copy.message"))
    }

    const goToFile = (itemId: string) => {
        const documentLinkUrl = window.location.protocol + '//' + window.location.host + '/file/' + itemId;
        window.location.href = documentLinkUrl;
    }

    return (
        <>
            <Box sx={{
                padding: '15px 30px',
                height: '100%'
            }}>
                <Box sx={{
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    border: '1px solid #0000001A',
                    borderRadius: '4px',
                    padding: '30px',
                    height: '100%'
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: '10px',
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: "row",
                            gap: '12px',
                        }}>
                            <ShareUser color="#22638D" />
                            <KeyDriveh4Header
                                color="#2D2D2D"
                                needEllipses={false}
                                text={t('SharedItem.Title')}
                                needBold
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <KeyDriveBodyMin
                                needEllipses={false}
                                color="#969696"
                                text={t('SharedItem.Subtitle')}
                                needBold={false}
                            />
                            {<ButtonWithPopoverFilter
                                users={usersSharedItem}
                                onApplyFilter={handleApplyFilter}
                            />}
                        </Box>
                        {loading ? <LinearProgress /> : <Divider />}
                        {sharedItems.items.length <= 0 && !loading ? (
                            <div style={{ height: "calc(100vh - 300px)" }}>

                                <EmptyContainer
                                    content={t('SharedItem.NotFound.Subtitle')}
                                    title={t('SharedItem.NotFound.Title')}
                                    icon={<ShareNotFound color="#d2e0e8" />}
                                />
                            </div>
                        ) : (
                                <div style={{
                                    width: "100%",
                                    height: "calc(100vh - 300px)",
                                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "19px"
                                }}>
                                    <GenericTablePagination<SharedItemModel>
                                        data={sharedItems.items.filter(item => item.usersAccess.length != 0)}
                                        columns={columns}
                                        page={sharedItems.pageCurrent}
                                        totalPages={sharedItems.totalPages}
                                        totalItems={sharedItems.totalItems}
                                        pageSize={sharedItems.pageSize}
                                        onPageChange={function (newPage: number): void {
                                            searchSharedItems({ ...requestDefaultPagination, page: newPage });
                                        }} />
                                </div>
                        )}
                    </Box>
                </Box>
            </Box>
            <KeyDriveDrawer
                isOpen={openDrawer}
            >
                <ShareFile
                    shareFileConfig={shareFileConfig!}
                    saveOkMetod={updatePanelSave}
                    setMessageSnackbar={setMessageSnack}
                    setShowSnackBar={setShowSnackBar}
                    setAlertColor={setAlertColor}
                    onClose={() => setOpenDrawer(false)}
                />
            </KeyDriveDrawer>
            <Snackbar
                open={showSnackBar}
                autoHideDuration={6000}
                onClose={() => setShowSnackBar(false)}
                message={messageSnack}
                variant={alertColor}
            />
            <ChoicerViwerModal
              idItem={itemIdConst!}
              isOpen={isOpenConst}
              setIsOpen={exibirViewerBoolean}
              name={nameConst!}
              extension={extensionConst!}
              previewWorkspaceListProps={{            
                workspaceItemList:ConvertWorkspaceToChoicerViwer(WorkSpaceItem),
                changeModalContent:updateContent,
                getWorkspaceWhenVisible:getWorkspaceWhenVisible,
                workMax:false
              }}
            />
        </>
    )
}
